function hasFileName(name) {
  if (name === null || name === undefined) return false;
  const value = String(name).trim();
  return value !== '' && value !== 'undefined' && value !== 'null';
}

export default function files(name, type) {
  if (!hasFileName(name)) return '';
  switch (type) {
    case "latest-news":
      return `${process.env.REACT_APP_IMAGE_URL}/uploads/latestNews/${name}`;
    case "offer":
      return `${process.env.REACT_APP_IMAGE_URL}/uploads/offer/${name}`;
    case "profile":
      return `${process.env.REACT_APP_IMAGE_URL}/uploads/profile/${name}`;
    case "cms":
      return `${process.env.REACT_APP_IMAGE_URL}/uploads/cms/${name}`;
    case "category":
      return `${process.env.REACT_APP_IMAGE_URL}/uploads/category/${name}`
    case "collection":
      return `${process.env.REACT_APP_IMAGE_URL}/uploads/collection/${name}`
    case "contact-support":
      return `${process.env.REACT_APP_IMAGE_URL}/uploads/contactSupport/${name}`
    case "cover_image":
      return `${process.env.REACT_APP_IMAGE_URL}/uploads/product/${name}`
    case "thumbnail":
      return `${process.env.REACT_APP_IMAGE_URL}/uploads/product/thumbnail/${name}`
    default:
      return ``;
  }
}

// Helper function to get the best available cover image from a product
export function getProductCoverImage(product, type = 'thumbnail') {
  // First, try the main cover_image
  if (product?.cover_image) {
    return files(product.cover_image, type);
  }

  // If not available, check color-specific cover images in order
  const colorCoverImages = [
    product?.yellow_cover_image,
    product?.yellow_gold_cover_image,
    product?.white_gold_cover_image,
    product?.rose_gold_cover_image,
    product?.blue_cover_image,
    product?.green_cover_image,
    product?.purple_cover_image,
    product?.pink_cover_image,
    product?.bronze_cover_image,
  ];

  // Return the first available color cover image
  for (const coverImage of colorCoverImages) {
    if (coverImage) {
      return files(coverImage, type);
    }
  }

  // Return empty string if no image is found
  return '';
}

// Helper function to get the correct video embed URL based on video provider
export function getVideoEmbedUrl(videoUrl) {
  if (!videoUrl) return '';

  // If it's already a full URL, check the provider
  if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
    // Extract YouTube video ID
    let videoId = '';
    if (videoUrl.includes('youtube.com/watch?v=')) {
      videoId = videoUrl.split('v=')[1]?.split('&')[0];
    } else if (videoUrl.includes('youtu.be/')) {
      videoId = videoUrl.split('youtu.be/')[1]?.split('?')[0];
    } else if (videoUrl.includes('youtube.com/embed/')) {
      videoId = videoUrl.split('embed/')[1]?.split('?')[0];
    } else {
      // Assume it's just the video ID, but strip any URL parameters
      videoId = videoUrl.split('&')[0]?.split('?')[0];
    }
    return `https://www.youtube.com/embed/${videoId}`;
  }

  // Cloudflare Stream
  if (videoUrl.includes('cloudflarestream.com') || videoUrl.includes('videodelivery.net')) {
    // If it's a full Cloudflare Stream URL
    if (videoUrl.includes('https://')) {
      return videoUrl;
    }
    // If it's just a playback ID, construct the embed URL
    return `https://iframe.videodelivery.net/${videoUrl}`;
  }

  // Vimeo
  if (videoUrl.includes('vimeo.com')) {
    let videoId = '';
    if (videoUrl.includes('vimeo.com/')) {
      videoId = videoUrl.split('vimeo.com/')[1]?.split('?')[0];
    } else {
      videoId = videoUrl;
    }
    return `https://player.vimeo.com/video/${videoId}`;
  }

  // If it's already a full embed URL, return as is
  if (videoUrl.startsWith('http://') || videoUrl.startsWith('https://')) {
    return videoUrl;
  }

  // Default: assume it's a YouTube video ID, but strip any URL parameters
  // This handles cases like "7t2alSnE2-I&list=PLe30vg_FG4OSKH_8zpLlnf4WpNlzL526E"
  const cleanVideoId = videoUrl.split('&')[0]?.split('?')[0];
  return `https://www.youtube.com/embed/${cleanVideoId}`;
}